var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._g(
      {
        class: [
          _vm.inline ? `${_vm.prefixCls}-inline` : `${_vm.prefixCls}`,
          _vm.direction ? `${_vm.prefixCls}-dir-${_vm.direction}` : "",
          _vm.wrap ? `${_vm.prefixCls}-${_vm.wrap}` : "",
          _vm.justify ? `${_vm.prefixCls}-justify-${_vm.justify}` : "",
          _vm.align ? `${_vm.prefixCls}-align-${_vm.align}` : "",
        ],
      },
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }